import { MJnr_Inst_Cnd } from '../models/domain/mjnr_inst_cnd';
import { Util } from './util';
import { MJoinerWrapper } from 'src/app/modules/design/transforms/mjoiner/mjoiner.wrapper';

export class MJnr_Inst_CndsUtil {
    private static instance: MJnr_Inst_CndsUtil;

    static getInstance(): MJnr_Inst_CndsUtil {
        if (!MJnr_Inst_CndsUtil.instance) {
            MJnr_Inst_CndsUtil.instance = new MJnr_Inst_CndsUtil();
        }

        return MJnr_Inst_CndsUtil.instance;
    }

    /**
    * MJnr_Inst_CndsUtil is a singleton class, so use MJnr_Inst_CndsUtil.getInstance() method instead of creating new MJnr_Inst_CndsUtil().
    */
    private constructor() {

    }

    copy(mJnr_Inst_Cnds: Array<MJnr_Inst_Cnd>): Array<MJnr_Inst_Cnd> {
        let mJnr_Inst_CndsTmp: Array<MJnr_Inst_Cnd> = new Array<MJnr_Inst_Cnd>();

        for (let i: number = 0; i < mJnr_Inst_Cnds.length; i++) {
            mJnr_Inst_CndsTmp.push(MJnr_Inst_Cnd.parse(mJnr_Inst_Cnds[i]));
        }

        return mJnr_Inst_CndsTmp;
    }

    copyFrom(mJnr_Inst_Cnds: Array<MJnr_Inst_Cnd>, mJnr_Inst_CndsTmp: Array<MJnr_Inst_Cnd>): void {
        let mJnr_Inst_CndsMap: Map<number, MJnr_Inst_Cnd> = new Map();

        for (let i: number = 0; i < mJnr_Inst_Cnds.length; i++) {
            let mJnr_Inst_Cnd: MJnr_Inst_Cnd = mJnr_Inst_Cnds[i] as MJnr_Inst_Cnd;
            mJnr_Inst_CndsMap.set(mJnr_Inst_Cnd.mJnr_Inst_Cnd_Id, mJnr_Inst_Cnd);
        }
        mJnr_Inst_Cnds.splice(0, mJnr_Inst_Cnds.length);

        for (let i: number = 0; i < mJnr_Inst_CndsTmp.length; i++) {
            let mJnr_Inst_CndTmp: MJnr_Inst_Cnd = mJnr_Inst_CndsTmp[i] as MJnr_Inst_Cnd;

            let mJnr_Inst_Cnd: MJnr_Inst_Cnd = mJnr_Inst_CndsMap.get(mJnr_Inst_CndTmp.mJnr_Inst_Cnd_Id);
            if (mJnr_Inst_Cnd) {
                mJnr_Inst_Cnd.copyFrom(mJnr_Inst_CndTmp);
            } else {
                mJnr_Inst_Cnd = MJnr_Inst_Cnd.parse(mJnr_Inst_CndTmp);
            }

            mJnr_Inst_Cnds.push(mJnr_Inst_Cnd);
        }
    }

    packMJnr_Inst_Cnd_Ids(list: Array<MJnr_Inst_Cnd>, field: string, objectWrapper: MJoinerWrapper) {
        if (!list) return;

        for (let i = 0; i < list.length; i++) {
            let util: Util = Util.getInstance();
            let fieldValue = util.readDotStringNotation(list[i], field);
            // objectWrapper.mJnr_Inst_Cnd_IdsHMap[fieldValue] = list[i];  TBD
        }
    }

    compare(mJnr_Inst_Cnds: Array<MJnr_Inst_Cnd>, mJnr_Inst_CndsTmp: Array<MJnr_Inst_Cnd>): string {
        let mJnr_Inst_CndsLength = mJnr_Inst_Cnds.length;
        let mJnr_Inst_CndsTmpLength = mJnr_Inst_CndsTmp.length;

        if (mJnr_Inst_CndsLength != mJnr_Inst_CndsTmpLength) {
            return 'MJnr_Inst_Cnd length is different.';
        }

        for (let i: number = 0; i < mJnr_Inst_CndsLength; i++) {
            let mJnr_Inst_Cnd: MJnr_Inst_Cnd = mJnr_Inst_Cnds[i] as MJnr_Inst_Cnd;
            let mJnr_Inst_CndTmp: MJnr_Inst_Cnd = mJnr_Inst_CndsTmp[i];

            if (mJnr_Inst_Cnd.compare(mJnr_Inst_CndTmp) != '') {
                return 'mJnr_Inst_Cnds [' + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(mJnr_Inst_Cnds: Array<MJnr_Inst_Cnd>): string {
        let str: string = '';

        for (let i: number = 0; i < mJnr_Inst_Cnds.length; i++) {
            str += mJnr_Inst_Cnds[i].toString();
        }

        return str;
    }
}